import LCLoading from './LCLoading';

export {
  LCLoading,
};
